import React, { useCallback, useState, useEffect, useRef } from "react"
import { useHistory } from "react-router-dom"
import Form from "@bappweb/form"
import Panel from "@bappweb/panel"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import Checkbox from "@bappweb/checkbox"
import Link from "@bappweb/link"
import Captcha from "@smpu-web/nested/form/captcha"
import FormMessage from "@smpu-web/globalmodules/form-message/index"
import Element from "@bappweb/element"
import { required } from "@bappweb/utils"
import {
  useCreateTokenMutation,
  useGetCaptchaMutation,
  useRefreshCaptchaMutation,
  useSendMutation
} from "../../../api/service"
import Block from "@bappweb/block"

function SmsForm() {
  const history = useHistory()
  const refForm = useRef(null)

  const [mobilePhone, setMobilePhone] = useState('')
  const [captchaValues, setCaptchaValues] = useState({
    tokenSessionId: "",
    captchaData: "",
    captcha: "",
    showCaptcha: false,
    captchaValidate: true
  })

  const [error, setError] = useState<string | null>(null)
  const [isFetching, setIsFetching] = useState(false)

  const [createToken] = useCreateTokenMutation()
  const handleChange = useCallback(
    (e) => {
      const name = e.target.name
      const value = e.target.value

      switch (name) {
        case "mobilePhone":
          setError(null)
          const mobilePhoneNumber = "90" + value.replace(/_/g, '').replace(/\s/g, '')
          setMobilePhone(mobilePhoneNumber)
          setCaptchaValues({
            ...captchaValues,
            captchaData: "",
            tokenSessionId: "",
            showCaptcha: false
          })
          if ((mobilePhoneNumber ?? "").length === 12) {
            setIsFetching(true)

            // @ts-ignore TODO
            // Captcha alanı temizlendiğinde validasyon hatası alıyor. O nedenle bu şekilde alanı temizliyoruz.
            refForm.current?.setValue("captcha", "")

            createToken(mobilePhoneNumber)
              .unwrap()
              .then((payload) => {
                if (!payload.IsError) {
                  setError("")
                  setCaptchaValues({
                    ...captchaValues,
                    tokenSessionId: payload.tokenSessionId
                  })
                } else {
                  setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                }
              })
              .finally(() => {
                setIsFetching(false)
              })
          }
          break;
        case "captcha":
          setError(null)
          setCaptchaValues({
            ...captchaValues,
            captcha: value
          })
          break
        default:
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [captchaValues]
  )

  const [getCaptcha] = useGetCaptchaMutation()
  useEffect(() => {
    if (captchaValues.captchaData === "" && captchaValues.tokenSessionId !== "") {
      setIsFetching(true)
      getCaptcha({
        guid: mobilePhone,
        TokenSessionId: captchaValues.tokenSessionId
      })
        .unwrap()
        .then((payload) => {
          if (!payload.IsError) {
            setCaptchaValues({
              ...captchaValues,
              captchaData: payload.captchaData,
              showCaptcha: true,
              captchaValidate: true
            })
          } else {
            setError(payload.ErrorMessage ? payload.ErrorMessage : "")
          }
        })
        .finally(() => {
          setIsFetching(false)
        })
    }
  }, [mobilePhone, getCaptcha, captchaValues])

  const [refreshCaptcha] = useRefreshCaptchaMutation()
  const handleCaptchaRefresh = useCallback(() => {
    setIsFetching(true)
    refreshCaptcha({
      guid: mobilePhone,
      TokenSessionId: captchaValues.tokenSessionId
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setCaptchaValues({
            ...captchaValues,
            captchaData: payload.captchaData,
            captchaValidate: true
          })
        } else {
          setError(payload.ErrorMessage ? payload.ErrorMessage : "")
        }
      })
      .finally(() => {
        setIsFetching(false)
      })
  }, [mobilePhone, captchaValues, refreshCaptcha])

  const [send] = useSendMutation()
  const handleSubmit = useCallback(
    (e?: React.BaseSyntheticEvent, values?: Record<string, any>) => {
      if (values && captchaValues.captcha !== "") {
        setIsFetching(true)
        send({
          mobilePhone: "90" + values.mobilePhone.replace(/\s/g, ''),
          captcha: captchaValues.captcha.toUpperCase(),
          kvkk: values.checkboxKvkk,
          TokenSessionId: captchaValues.tokenSessionId
        })
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              setError(null)
              history.push("/result/success")
            } else {
              setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              window.scrollTo({
                top: 0
              })
              refreshCaptcha({
                guid: mobilePhone,
                TokenSessionId: captchaValues.tokenSessionId
              })
                .unwrap()
                .then((payload) => {
                  if (!payload.IsError) {
                    setCaptchaValues({
                      ...captchaValues,
                      captcha: "",
                      showCaptcha: true,
                      captchaData: payload.captchaData,
                      captchaValidate: false
                    })
                  } else {
                    setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                  }
                })
                .finally(() => {
                  setIsFetching(false)
                })
            }
          })
          .finally(() => {
            setIsFetching(false)
          })
      }
    },
    [captchaValues, mobilePhone, send, refreshCaptcha, history]
  )

  return (
    <Panel connected={false} loading={isFetching} className="sms-inner">
      <Element type="h3">SMS Linki ile İndirin</Element>
      <Block className="sms-content">
        <Form
          id="initial-info-form"
          name="initial-info-form-name" onSubmit={handleSubmit} onChange={handleChange} grid={false} ref={refForm}>
          <FormMessage className={"form-msg-error"} error={error}></FormMessage>
          <Panel hasFooter connected={false}>
            <Block type="div">
              <Element type="p" className="">
                {"Akbank Mobil'in bir SMS ile cebinize gelmesi için telefon numaranızı ve güvenlik kodunu yazın."}
              </Element>
            </Block>
            <TextField
              label='Cep Telefon No'
              type="text"
              placeholder="5__ ___ __ __"
              mask="999 999 99 99"
              name="mobilePhone"
              getMaskedValue={true}
              maxLength={13}
              validations={[required("Cep Telefonu alanı zorunludur.")]}
            />
            {captchaValues.showCaptcha && (
              <Captcha
                label="Güvenlik Kodu"
                id="captcha"
                type="text"
                name="captcha"
                placeholder="Güvenlik Kodu"
                captcha={captchaValues.captchaData}
                value={captchaValues.captcha}
                maxLength={4}
                maxRefreshCount={3}
                refreshClick={handleCaptchaRefresh}
                validations={[required("Lütfen güvenlik kodunu giriniz.")]}
              />
            )}
            <div className="checkbox-group">
              <Checkbox
                className="cb-position-fix"
                name="checkboxKvkk"
                validations={[required("Lütfen onay kutusunu işaretleyiniz.")]}
                validateOnSubmit={true}
                block>
                <Link
                  href="//www.akbank.com/Documents/KISISELVERILERINKORUNMASI_TR.pdf"
                  text={"Kişisel Verilerin Korunması Kanunu Hakkında Bilgilendirme 'yi"}
                  inline
                  target="_blank"
                />
                {" okudum."}
              </Checkbox>
            </div>
            <Button text="SMS Gönder" className="form-sms-button" type="submit" fetching={isFetching} disabled={isFetching} />
            {!captchaValues.showCaptcha && (<Element type="p" className="captcha-content-hide" />)}
          </Panel>
        </Form>
        <Element type="br" />
        <Element type="span">*SMS gönderimi ücretsizdir</Element>
      </Block>
    </Panel>
  )
}

export default SmsForm
